export default __webpack_public_path__ + "static/media/sti3-icon.4ab55239.png";